<template>
  <div class="c-searchfield">
    <form action="/search" method="get">
      <input type="search" id="ajax_search" name="sSearch" autocomplete="off" autocapitalize="off" placeholder="Suchbegriff..." maxlength="30">
      <button type="submit" class="pdi-loupe"><span>Suchen</span>&nbsp;</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Search'
}
</script>

<style scoped lang="sass">
  .c-searchfield
    float: right
    form
      margin-right: 0
      input
        color: $dark-blue
        border: 1px solid $light-grey
        border-radius: $border-radius 0 0 $border-radius
        padding: 0.6em 0.9em
        float: left
        width: auto
        transition: all 250ms cubic-bezier(0.860, 0.000, 0.070, 1.000)
        width: 10em
        outline: none
        appearance: none
        &:focus
          width: 22em

      button
        background: $blue
        border: 1px solid $blue
        color: #fff
        border-radius: 0 $border-radius $border-radius 0
        padding: 0.6em 0.9em
        width: 3em
        float: left
        position: relative
        cursor: pointer
        &:hover
          background-color: $orange
          border-color: $orange

        span
          display: none

        //&:hover
          .button-hover
        //&:active
          .button-active
        &:before
          position: absolute
          font-size: 1.3em
          right: 0.9em

</style>
